{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "olenka/text-with-boxes-wrapper",
	"version": "1.0.0",
	"title": "Text with Boxes Wrapper",
	"category": "olenka-general",
	"icon": "grid-view",
	"description": "Text with boxes section with tagline, heading, description and inner boxes grid",
	"supports": {
		"html": false
	},
	"attributes": {
		"tagline": {
			"type": "string",
			"default": "What's inside"
		},
		"heading": {
			"type": "string",
			"default": "A practical starter, built around modern WordPress workflow"
		},
		"description": {
			"type": "string",
			"default": "Olenka is designed as a clean working base for custom theme development. Instead of filling the homepage with decoration, it focuses on the pieces that matter most when starting a real project."
		},
		"backgroundColor": {
			"type": "string",
			"default": ""
		},
		"subline": {
			"type": "string",
			"default": "Made for developers who prefer a modern workflow with room for clean customization."
		},
		"displaySubline": {
			"type": "boolean",
			"default": false
		},
		"showBorderBottom": {
			"type": "boolean",
			"default": true
		}
	},
	"textdomain": "olenka"
}
